import { defineComponent as _defineComponent } from 'vue'
import mapboxgl, { EventData, MapMouseEvent, MapTouchEvent } from 'mapbox-gl'
import LocationDTO from '@/models/location'
import GeoJsonSource from '../mapbox/GeoJsonSource.vue'
import LayerGroup from '../mapbox/LayerGroup.vue'
import { useMap } from '../mapbox/context'
import { useFieldView } from '../FieldViewState'
import { computed, onMounted, onBeforeUnmount } from 'vue'
import { locationPinStyle } from './styles/location-pin'


export default /*#__PURE__*/_defineComponent({
  __name: 'LocationsSelectedLayer',
  props: {
    layerId: null,
    sourceId: null,
    showLocation: null,
    before: null,
    hideLayer: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  layerId: string
  sourceId: string
  showLocation: LocationDTO | null
  before?: string
  hideLayer?: boolean
}

const { map } = useMap()
const { fieldViewState: state, setSelectedLocation } = useFieldView()



onMounted(() => {
  map.value.on('mousedown', props.layerId, allowDraggingIfEditingOne)
  map.value.on('touchstart', props.layerId, onTouchStart)
})

onBeforeUnmount(() => {
  map.value.off('mousedown', props.layerId, allowDraggingIfEditingOne)
  map.value.off('touchstart', props.layerId, onTouchStart)
})

const data = computed(() => {
  const location = props.showLocation

  const features = location
    ? [
        {
          id: location.id ?? undefined,
          type: 'Feature',
          geometry: {
            type: 'Point',
            coordinates: [location.longitude!, location.latitude!],
          },
          properties: {
            Name: location.location,
            Icon: location.icon,
            IconColor: location.locationStatusColorHexCode,
            OwnerId: location.ownerId,
          },
        },
      ]
    : []

  return {
    type: 'FeatureCollection',
    features,
  }
})

const layers: mapboxgl.SymbolLayer[] = [
  {
    id: props.layerId,
    source: props.sourceId,
    type: 'symbol',
    layout: {
      ...locationPinStyle.layout,
      'symbol-sort-key': 0,
      'icon-allow-overlap': true,
      'icon-size': 1.5,
      'text-radial-offset': 2,
      'text-allow-overlap': true,
      'text-optional': false,
      'text-size': {
        stops: [
          [15, 11],
          [15.5, 12],
          [17, 14],
        ],
      },
    },
    paint: {
      ...locationPinStyle.paint,
      'text-opacity': 1,
    },
  },
]

const onTouchStart = (e: MapTouchEvent & EventData) => {
  const isNotMultiTouch = e.points.length === 1
  if (isNotMultiTouch) {
    allowDraggingIfEditingOne(e)
  }
}

const allowDraggingIfEditingOne = (
  event: (MapMouseEvent | MapTouchEvent) & EventData
) => {
  if (state.value.editMode) {
    event.preventDefault()

    if (event.type === 'mousedown') {
      map.value.on('mousemove', updateSelectedLatLng)
      map.value.once('mouseup', onUp)
    } else {
      map.value.on('touchmove', updateSelectedLatLng)
      map.value.once('touchend', onUp)
    }
  }
}

const updateSelectedLatLng = (
  e: (MapMouseEvent | MapTouchEvent) & EventData
) => {
  map.value.getCanvas().style.cursor = 'grabbing'

  setSelectedLocation({
    ...state.value.selectedLocation!,
    latitude: e.lngLat.lat,
    longitude: e.lngLat.lng,
  })
}

const onUp = (e: (MapMouseEvent | MapTouchEvent) & EventData) => {
  map.value.getCanvas().style.cursor = ''

  setSelectedLocation({
    ...state.value.selectedLocation!,
    latitude: e.lngLat.lat,
    longitude: e.lngLat.lng,
  })

  map.value.off('mousemove', updateSelectedLatLng)
  map.value.off('touchmove', updateSelectedLatLng)
}

return { __sfc: true,map, state, setSelectedLocation, props, data, layers, onTouchStart, allowDraggingIfEditingOne, updateSelectedLatLng, onUp, GeoJsonSource, LayerGroup }
}

})